module.exports = __webpack_public_path__ + "img/空白（版心宽+居右页码）.80a9609f.jpg";